// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.sabay.wallet",
    name: "Sabay Wallet App",
    homepage: "https://wallet.sabay.com",
    image_id: "c4df7014-abaf-4016-8180-fb994804b400",
    app: {
        browser: null,
        ios: "https://apps.apple.com/kh/app/sabay-wallet/id6449341309",
        android: "https://play.google.com/store/apps/details?id=kh.com.sabay.sabaywallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "myApp://kh.com.sabay.sabaywallet",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map